import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  RibbonDetail,
  RibbonDetailsState,
  ManufacturerRibbonResponse,
  ManufacturerRibbonsListingQueryParameters,
} from "./type";

const initialState: RibbonDetailsState = {
  ribbonDetails: {
    _id: "",
    name: "",
    icon: "",
    createdAt: "",
    criteria: [],
  },

  manufacturerRibbonsListing: {
    data: [],
    total: 0,
    limit: 0,
    pageNo: 0,
    nextHit: 0,
    totalPage: 0,
  },

  manufacturerRibbonsListingQueryParameters: {
    pageNo: 1,
    limit: 10,
  },
};

const rewardSlice = createSlice({
  name: "reward",
  initialState,
  reducers: {
    setRibbonDetails: (state, action: PayloadAction<RibbonDetail>) => {
      state.ribbonDetails = action.payload;
    },

    resetRibbonDetails: (state) => {
      state.ribbonDetails = {
        _id: "",
        name: "",
        icon: "",
        createdAt: "",
        criteria: [],
      };
    },

    setManufacturerRibbonsListing: (
      state,
      action: PayloadAction<ManufacturerRibbonResponse>,
    ) => {
      if (action.payload.pageNo > 1) {
        state.manufacturerRibbonsListing = {
          ...action.payload,
          data: [
            ...state.manufacturerRibbonsListing.data,
            ...action.payload.data,
          ],
        };
      } else {
        state.manufacturerRibbonsListing = action.payload;
      }
    },

    setManufacturerRibbonsListingQueryParameters: (
      state,
      action: PayloadAction<ManufacturerRibbonsListingQueryParameters>,
    ) => {
      state.manufacturerRibbonsListingQueryParameters = action.payload;
    },
  },
});

export const {
  setRibbonDetails,
  resetRibbonDetails,
  setManufacturerRibbonsListing,
  setManufacturerRibbonsListingQueryParameters,
} = rewardSlice.actions;
export default rewardSlice.reducer;
